import { create } from '@thoughtspot/logger';
import { ChartToTSEvent } from '@thoughtspot/ts-chart-sdk';
import _ from 'lodash';
import { getActionHandlerEventProcessor } from './action-handler-events';
import { getCloseAxisMenuEventProcessor, getOpenAxisMenuEventProcessor, } from './axis-menu-events';
import { getCloseContextMenuEventProcessor, getOpenContextMenuEventProcessor, } from './context-menu-events';
import { getGetDataForQueryEventProcessor } from './data-events';
import { NativeChartToTSEvent, } from './event-processor.types';
import { getLabelTranslationsProcessor } from './label-translation-events';
import { getSessionFlagsProcessor } from './native-chart-events/flag-events';
import { getLDFlagEventProcessor } from './native-chart-events/get-ld-flags';
import { getInitStartEventProcessor, getRenderCompleteEventProcessor, getRenderErrorEventProcessor, getRenderStartEventProcessor, } from './render-events';
import { getGetTMLStringEventProcessor, getSetTMLStringEventProcessor, } from './tml-events';
import { getHideToolTipEventProcessor, getShowToolTipEventProcessor, } from './tooltip-events';
import { getUpdateVisualPropsEditorDefinitionEventProcessor } from './update-visual-props-editor';
import { getUpdateChartConfigEventProcessor } from './update-chart-config';
import { getVisualPropUpdateEventProcessor } from './visual-prop-events';
import { getShowGlobalAlertToastEventProcessor } from './show-global-alert-toast';
import { getShowGlobalAlertBannerEventProcessor } from './show-global-alert-banner';
import { getHideGlobalAlertBannerEventProcessor } from './hide-global-alert-banner';
import { getTrackChartInteractionEventProcessor } from './track-chart-interaction';
import { getDispatchChartInteractionEventProcessor } from './dispatch-chart-interaction';
const logger = create('CustomChartEventProcessor');
const eventProcessorMap = {
    [ChartToTSEvent.RenderComplete]: getRenderCompleteEventProcessor,
    [ChartToTSEvent.RenderStart]: getRenderStartEventProcessor,
    [ChartToTSEvent.RenderError]: getRenderErrorEventProcessor,
    [ChartToTSEvent.InitStart]: getInitStartEventProcessor,
    [ChartToTSEvent.OpenContextMenu]: getOpenContextMenuEventProcessor,
    [ChartToTSEvent.CloseContextMenu]: getCloseContextMenuEventProcessor,
    [ChartToTSEvent.UpdateVisualProps]: getVisualPropUpdateEventProcessor,
    [ChartToTSEvent.GetTMLString]: getGetTMLStringEventProcessor,
    [ChartToTSEvent.SetTMLString]: getSetTMLStringEventProcessor,
    [ChartToTSEvent.GetDataForQuery]: getGetDataForQueryEventProcessor,
    [ChartToTSEvent.ShowToolTip]: getShowToolTipEventProcessor,
    [ChartToTSEvent.HideToolTip]: getHideToolTipEventProcessor,
    [ChartToTSEvent.OpenAxisMenu]: getOpenAxisMenuEventProcessor,
    [ChartToTSEvent.CloseAxisMenu]: getCloseAxisMenuEventProcessor,
    [ChartToTSEvent.ActionHandler]: getActionHandlerEventProcessor,
    [NativeChartToTSEvent.GetBlinkFlags]: getSessionFlagsProcessor,
    [NativeChartToTSEvent.GetLDFlags]: getLDFlagEventProcessor,
    [ChartToTSEvent.GetLabelTranslation]: getLabelTranslationsProcessor,
    [ChartToTSEvent.UpdateChartConfig]: getUpdateChartConfigEventProcessor,
    [ChartToTSEvent.UpdateVisualPropEditorDefinition]: getUpdateVisualPropsEditorDefinitionEventProcessor,
    [ChartToTSEvent.ShowGlobalAlertToast]: getShowGlobalAlertToastEventProcessor,
    [ChartToTSEvent.ShowGlobalAlertBanner]: getShowGlobalAlertBannerEventProcessor,
    [ChartToTSEvent.HideGlobalAlertBanner]: getHideGlobalAlertBannerEventProcessor,
    [ChartToTSEvent.TrackChartInteraction]: getTrackChartInteractionEventProcessor,
    [ChartToTSEvent.DispatchChartInteraction]: getDispatchChartInteractionEventProcessor,
};
const initEventProcessor = (eventType, eventCallbackProps) => {
    if (_.isNil(eventProcessorMap[eventType])) {
        logger.error(`trying to register an event which doesnt exist. eventType: ${eventType}`);
        return null;
    }
    return eventProcessorMap[eventType](eventCallbackProps);
};
const processCallback = (messageResponseData) => {
    const responseObject = {
        hasError: _.isNil(messageResponseData?.isValid)
            ? false
            : !messageResponseData?.isValid,
        data: messageResponseData,
    };
    return responseObject;
};
const EventProcessor = (setError) => {
    let eventState = {};
    const setEventState = (newEventState) => {
        eventState = newEventState;
    };
    const onEvent = (eventType, eventCallbackProps) => {
        const newEventState = {
            ...eventState,
            [eventType]: initEventProcessor(eventType, eventCallbackProps),
        };
        setEventState(newEventState);
    };
    const processEvent = async (msgEventData) => {
        logger.debug('Processing the received event...', msgEventData);
        if (!msgEventData?.eventType) {
            return null;
        }
        let messageResponse = {
            isValid: false,
            errors: [`${msgEventData.eventType} is not yet implemented`],
        };
        if (msgEventData?.eventType in ChartToTSEvent ||
            msgEventData?.eventType in NativeChartToTSEvent) {
            const eventType = msgEventData?.eventType;
            if (!_.isNil(eventState[eventType])) {
                const eventProcessor = eventState[eventType];
                const validationResponse = eventProcessor.validateEventPayload(msgEventData);
                if (validationResponse.isValid) {
                    messageResponse = await eventProcessor.executeEvent(msgEventData);
                }
                else {
                    messageResponse = validationResponse;
                }
            }
        }
        else {
            logger.warn('Invalid event type received.');
        }
        const isValidEventType = msgEventData?.eventType in ChartToTSEvent;
        if (!messageResponse?.isValid) {
            logger.warn(messageResponse?.errors);
            if (isValidEventType) {
                setError(messageResponse?.errors?.[0]);
            }
        }
        return processCallback(messageResponse);
    };
    return { onEvent, processEvent };
};
const testHooks = {
    initEventProcessor,
    processCallback,
};
export { EventProcessor, testHooks };
//# sourceMappingURL=event-processor.js.map